import { MutableRefObject, useEffect } from 'react';

/**
 * Hook that alerts clicks outside of the passed ref
 */
export const useOutsideHandler = (ref: MutableRefObject<HTMLElement | null>, handleClickOutside: () => void) => {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function _handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        handleClickOutside();
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', _handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', _handleClickOutside);
    };
  }, [ref]);
};
